import { render, staticRenderFns } from "./rh.vue?vue&type=template&id=4c6e84ce&scoped=true&"
import script from "./rh.vue?vue&type=script&lang=js&"
export * from "./rh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e84ce",
  null
  
)

export default component.exports